
import sha256 from "js-sha256"
import { Button } from "element-ui"
import authContent from "@/components/auth/authContent.vue"
import { AUTH_TYPE, LoginTypeEnum, AUTH_ERROR_CODE } from "@/constants/auth"
import { login } from "@/api/authentication"
import Dialog from "@/components/auth/Modal.vue"
import { getDomain, getDeviceId } from "@/utils/utils"

export default {
  components: {
    authContent,
    Dialog,
    [Button.name]: Button
  },
  //
  data() {
    return {
      authContentType: AUTH_TYPE.LOGIN,
      dialogVisible: false
    }
  },
  head() {
    return {
      title: `${this.$t("pageTitle.login")}`
    }
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    handleGoToSignup() {
      this.$navigation.push("/auth/signup")
    },
    async handleLogin(value) {
      try {
        const res = await login({
          phone: value.phoneNumber,
          pwd: sha256(value.password),
          loginType: value.code ? LoginTypeEnum.sms : LoginTypeEnum.password,
          authCode: value.code,
          // 保持登录
          keepactive: 1,
          deviceId: getDeviceId(),
          domain: getDomain(),
          loginChannel: 3
        })
        this.$message.success(this.$t("common.loginInSuccess"))
        if (this.$route.query?.redirect?.includes(window.location.hostname)) {
          window.location.replace(this.$route.query.redirect || "/")
        } else {
          window.location.replace("/")
        }
      } catch (error) {
        if (error.code === AUTH_ERROR_CODE.MOBILE_NOT_REGISTER) {
          this.dialogVisible = true
        } else {
          this.$message.error(error.result)
        }
        console.log(error)
      }
    }
  }
}
